import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  InputGroup,
  Input,
  Form,
  SelectPicker,
  Message,
  DatePicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
} from 'rsuite'
import { isValidators, requiredFiled, getMaxLengthData } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../CustomIconMessageInfo'
import scrollToComponent from 'react-scroll-to-component'
import ActivityProductivityWidget from './ActivityProductivity/ActivityProductivityWidget'
import ActivityBudgetTable from './ActivityBudgetTable'
import { checkStatusProjectActivityMain, getActivityProduct } from '../../../redux/actions/budget'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { dateMoment, filterYear, getYearMonthMapThai } from '../../../utils/dataUtil'
import NumberFormat from 'react-number-format'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'

export default function ActivityBudgetForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  setError,
  clearErrors,
  getValues,
  onSubmit,
  onDelete,
  onExpanded,
  onEditActivityBudget,
  setExpanded,
  projectVersionId,
  ...props
}) {
  const { isEditDetail, editDetailIndex, isDeleteError, isError, loading } = props

  const [schema, setSchema] = useState(_schema)
  const [section, setSection] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [startEndList, setStartEndList] = useState([])
  const [ativityMonths, setAtivityMonths] = useState([])
  const [isEdit, setIsEdit] = useState(props.isEditDetail)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [periodType, setPeriodType] = useState()
  const [activityProductivitySchema, setActivityProductivitySchema] = useState()
  const [isLoading, setIsLoading] = useState()
  const [panelExpanded, setPanelExpanded] = useState()
  const [optionsYear, setOptionsYear] = useState([])
  const [optionsMonthData, setOptionsMonthData] = useState(new Map())
  const [disableActivityName, setDisableActivityName] = useState(false)

  const [activityDetailValue, setActivityDetailValue] = useState(
    schema?.activityDetail?.value?.length || 0
  )
  const [textActivityNameValue, setTextActivityNameValue] = useState(schema?.activity?.value.length || 0)

  const [activityDetail, setActivityDetail] = useState(schema?.activityDetail?.value)
  const [activityName, setActivityName] = useState(schema?.activity?.value)

  const projectId = projectVersionId || sessionStorage.getItem('projectId')

  const selectedId = 'selectedId'

  useEffect(() => {
    setPanelExpanded(false)
  }, [onExpanded])

  useEffect(() => {
    setSchema(_schema)
    setIsEdit(props.isEditDetail)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
    // setActivityDetailValue(schema?.activityDetail?.value)
    setValueOptions()
  }, [_schema])

  const setValueOptions = () => {
    if (
      schema.activityDurationDate.projectStartDate &&
      schema.activityDurationDate.projectEndDate
    ) {
      let years = filterYear(
        schema.activityDurationDate.projectStartDate,
        schema.activityDurationDate.projectEndDate,
        schema.activityDurationYear.options
      )
      setOptionsYear(years)

      let rsMap = getYearMonthMapThai(
        schema.activityDurationDate.projectStartDate,
        schema.activityDurationDate.projectEndDate
      )

      setOptionsMonthData(rsMap)
    }
  }

  const handleGetSchema = async (activityId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _productivitySchema = await getActivityProduct(projectId, activityId)

      // setActivityBudgetSchema(_budgetSchema)
      setActivityProductivitySchema(_productivitySchema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    if (isEditDetail) {
      let data = schema.value[editDetailIndex]
      setStartEndList(data.activityDurationDate || [])
      setAtivityMonths(data.activityDurationMonth || '')
      handleGetSchema(data.id)

      setEditId(data.id)
    }
  }, [isEditDetail, editDetailIndex])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
    setActivityDetailValue(0)
    setTextActivityNameValue(0)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const handleOnEdit = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await checkStatusProjectActivityMain(projectId, rowData.id)

      if(response?.status == '200'){
        let disableActivityName = response?.statusCode == '2'
        handleEdit(rowData, disableActivityName)
      }else{
        notification.open('error', {
          title: response?.ErrMsg || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
      
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
          title: e?.response?.data?.errors?.message 
          || e?.response?.data?.errorMessage 
          || DEFAULT_ERR_MSG,
          duration: 5000,
        })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onAdd = () => {
    let schemaObj = schema
    schemaObj.activityDetail.value = ''
    schemaObj.activity.value = ''
    schemaObj.activityDurationExpectedStart.value = ''
    schemaObj.periodType.value = 1
    schemaObj.totalMonth.value = ''
    schemaObj.underPurpose.value = []

    setTextActivityNameValue(0)
    setActivityDetailValue(0)

    setSchema(schemaObj)
    setPeriodType(1)
    setStartEndList([
      {
        start: '',
        end: '',
      },
    ])
    setEditId()
    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)

    setValue(schemaObj.periodType.name, 1)
    setValue(selectedId)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handleEdit = (rowData, disableActivityName) => {
    // console.log('handleEdit ', rowData)
    let schemaObj = schema
    setStartEndList(rowData.activityDurationDate)
    setAtivityMonths(rowData.activityDurationMonth)

    schemaObj.activityDetail.value = rowData.activityDetail
    schemaObj.activity.value = rowData.activity
    schemaObj.activityDurationExpectedStart.value = rowData.activityDurationExpectedStart
    schemaObj.periodType.value = rowData.periodType
    schemaObj.totalMonth.value = rowData.totalMonth
    schemaObj.underPurpose.value = rowData.underPurpose[0]

    setTextActivityNameValue(rowData.activity.length)
    setActivityDetailValue(rowData.activityDetail.length)

    setActivityName(rowData.activity)
    setActivityDetail(rowData.activityDetail)

    setSchema(schemaObj)
    setIsAdd(true)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditId(rowData.id)
    setPeriodType(rowData.periodType)

    setValue(selectedId, rowData.id)
    setValue(schemaObj.activityDetail.name, rowData.activityDetail)
    setValue(schemaObj.activity.name, rowData.activity)
    setValue(schemaObj.activityDurationDate.name, rowData.activityDurationDate)
    setValue(schemaObj.activityDurationExpectedStart.name, rowData.activityDurationExpectedStart)
    setValue(schemaObj.totalMonth.name, rowData.totalMonth)
    setValue(schemaObj.periodType.name, rowData.periodType)
    setValue(schemaObj.underPurpose.name, rowData.underPurpose[0])
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    setValueOptions()

    setDisableActivityName(disableActivityName)
  }

  const handleEditActivityBudget = (rowData) => {
    // console.log('handleEditActivityBudget ', rowData)
    let schemaObj = schema

    setStartEndList(rowData.activityDurationDate)
    setAtivityMonths(rowData.activityDurationMonth)

    schemaObj.activityDetail.value = rowData.activityDetail
    schemaObj.activity.value = rowData.activity
    schemaObj.activityDurationExpectedStart.value = rowData.activityDurationExpectedStart
    schemaObj.periodType.value = rowData.periodType
    schemaObj.totalMonth.value = rowData.totalMonth
    schemaObj.underPurpose.value = rowData.underPurpose[0] || rowData.underPurpose

    setSchema(schemaObj)
    setIsAdd(false)
    setIsDeleteFail(false)
    setIsSaveError(false)
    setEditId(rowData.id)
    setPeriodType(rowData.periodType)
    setPanelExpanded(false)
    setIsEdit(true)
    setExpanded(false, rowData)

    handleGetSchema(rowData.id)

    setValue(selectedId, rowData.id)
    setValue(schemaObj.activityDetail.name, rowData.activityDetail)
    setValue(schemaObj.activity.name, rowData.activity)
    setValue(schemaObj.activityDurationDate.name, rowData.activityDurationDate)
    setValue(schemaObj.activityDurationExpectedStart.name, rowData.activityDurationExpectedStart)
    setValue(schemaObj.totalMonth.name, rowData.totalMonth)
    setValue(schemaObj.periodType.name, rowData.periodType)
    setValue(schemaObj.underPurpose.name, rowData.underPurpose)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handlePlusDate = () => {
    let arr = [...startEndList]
    arr.push({ start: '', end: '' })
    setStartEndList(arr)
  }

  const handleDeleteDate = (index) => {
    let arr = [...startEndList]
    arr.splice(index, 1)
    setStartEndList(arr)
  }

  const handlePlusMonth = () => {
    let arr = [...ativityMonths]
    arr.push({ month: '', year: '' })
    setAtivityMonths(arr)
  }

  const handleDeleteMonth = (index) => {
    let arr = [...ativityMonths]
    arr.splice(index, 1)
    setAtivityMonths(arr)
  }

  const onMonthChange = (props, item, index, value) => {
    let list = [...ativityMonths]

    let isDup = ativityMonths.some(
      (e) => e.year && e.year == item.year && e.month && e.month == value
    )

    if (isDup) {
      let yearObj = optionsYear.find((e) => item.year == e.value)
      setError('monthYearDup_' + index, {
        type: 'manual',
        message: `ปี ${yearObj?.label} , เดือน ${
          optionsMonthData?.get(parseInt(yearObj?.value)).find((e) => value == e.value).label
        } ที่เลือกซ้ำ`,
      })
      list[index].month = ''
      props.onChange()
    } else {
      list[index].month = value
      props.onChange(value)
      setValue(schema.activityDurationMonth.name, list)
      clearErrors('monthYearDup_' + index)
    }

    setAtivityMonths(list)
    setValue(schema.activityDurationMonth.name, list)
  }

  const onYearChange = (props, item, index, value) => {
    let list = [...ativityMonths]

    let isDup = ativityMonths.some(
      (e) => e.year && e.year == value && e.month && e.month == item.month
    )

    if (isDup) {
      let yearObj = optionsYear.find((e) => item.year == e.value)
      setError('monthYearDup_' + index, {
        type: 'manual',
        message: `ปี ${yearObj?.label} , เดือน ${
          optionsMonthData?.get(parseInt(yearObj?.value)).find((e) => value == e.value).label
        } ที่เลือกซ้ำ`,
      })

      list[index].year = ''
      props.onChange()
    } else {
      list[index].year = value
      list[index].month = ''
      props.onChange(value)
      setValue(schema.activityDurationMonth.name, list)
      clearErrors('monthYearDup_' + index)
    }
    // console.log(errors)
    setAtivityMonths(list)
    setValue(schema.activityDurationMonth.name, list)
  }

  const renderStartEndDate = () => {
    // console.log('renderStartEndDate', startEndList)

    return startEndList.map((item, index) => {
      return (
        <>
          {(errors['startDate_' + index] || errors['endDate_' + index]) && (
            <Row>
              <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 150 }}>
                <ErrorMessage error={errors['startDate_' + index]} />
              </Col>
              <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 150 }}>
                <ErrorMessage error={errors['endDate_' + index]} />
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={2} sm={2} md={2} lg={2} style={{ marginTop: 15, width: 80 }}>
              <span>ช่วงที่ {index + 1}</span>
            </Col>
            <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 150 }}>
              {/* <ErrorMessage error={errors['startDate_' + index]} /> */}
              <Controller
                key={'startDate_' + index}
                name={'startDate_' + index}
                control={control}
                rules={isValidators(schema.activityDurationDate.validators)}
                defaultValue={item.start}
                render={(props) => {
                  return (
                    <DatePicker
                      disabled={isEdit}
                      value={item.start}
                      style={{ width: '100%' }}
                      format={DATE_PICKER_FORMAT}
                      placeholder={schema.activityDurationDate.preLabel}
                      locale={LOCAL_DAY_TH}
                      onChange={(value) => {
                        const date = new Date(value);
                        const ISODate = new Date(Date.UTC(
                            date.getFullYear(),
                            date.getMonth(),
                            date.getDate()
                        )).toISOString();

                        let list = [...startEndList]
                        list[index].start = ISODate
                        setStartEndList(list)
                        // setValue('startDate_' + index, value)
                        props.onChange(ISODate)
                        setValue(schema.activityDurationDate.name, list)
                      }}
                      calendarDefaultDate={schema.activityDurationDate.projectStartDate}
                      disabledDate={(date) => {
                        return dateMoment(
                          date,
                          getValues('startDate_' + index)
                            ? schema.activityDurationDate.projectStartDate
                            : schema.activityDurationDate.projectStartDate,
                          getValues('endDate_' + index)
                            ? getValues('endDate_' + index)
                            : schema.activityDurationDate.projectEndDate
                        )
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col xs={10} sm={10} md={10} lg={10} style={{ marginTop: 10, width: 150 }}>
              {/* <ErrorMessage error={errors['endDate_' + index]} /> */}
              <Controller
                key={'endDate_' + index}
                name={'endDate_' + index}
                control={control}
                rules={isValidators(schema.activityDurationDate.validators)}
                defaultValue={item.end}
                render={(props) => {
                  return (
                    <DatePicker
                      disabled={isEdit}
                      value={item.end}
                      style={{ width: '100%' }}
                      format={DATE_PICKER_FORMAT}
                      placeholder={schema.activityDurationDate.postLabel}
                      locale={LOCAL_DAY_TH}
                      onChange={(value) => {
                        const date = new Date(value);
                        const ISODate = new Date(Date.UTC(
                            date.getFullYear(),
                            date.getMonth(),
                            date.getDate()
                        )).toISOString();

                        let list = [...startEndList]
                        list[index].end = ISODate
                        setStartEndList(list)
                        // setValue('endDate_' + index, value)
                        props.onChange(ISODate)
                        setValue(schema.activityDurationDate.name, list)
                      }}
                      calendarDefaultDate={schema.activityDurationDate.projectStartDate}
                      disabledDate={(date) => {
                        return dateMoment(
                          date,
                          getValues('startDate_' + index)
                            ? getValues('startDate_' + index)
                            : schema.activityDurationDate.projectStartDate,
                          schema.activityDurationDate.projectEndDate
                        )
                      }}
                    />
                  )
                }}
              />
            </Col>
            {!isEdit && (
              <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 10, width: 50 }}>
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-cancel"
                  disabled={isEdit}
                  icon={<Icon className="bt-gost-icon-radius-cancel" icon="trash" />}
                  onClick={() => handleDeleteDate(index)}
                ></IconButton>
              </Col>
            )}

            {startEndList.length - 1 === index && !isEdit && (
              <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 10, width: 50 }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                  onClick={() => handlePlusDate()}
                ></IconButton>
              </Col>
            )}
          </Row>
        </>
      )
    })
  }

  const renderAtivityMonths = ativityMonths.map((item, index) => {
    var valYear = typeof item.year == 'number' ? item.year.toString() : item.year

    return (
      <Row key={index}>
        <ErrorMessage
          style={{ marginTop: 10 }}
          error={errors[schema.activityDurationYear.name + '_' + index]}
        />

        <ErrorMessage
          style={{ marginTop: 10 }}
          error={errors[schema.activityDurationMonth.name + '_' + index]}
        />

        <ErrorMessage
          style={{ marginTop: 10 }}
          closable
          onClose={() => {
            clearErrors('monthYearDup_' + index)
          }}
          error={errors['monthYearDup_' + index]}
        />

        <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, width: '11em' }}>
          <Controller
            key={schema.activityDurationYear.name + '_' + index}
            name={schema.activityDurationYear.name + '_' + index}
            control={control}
            rules={isValidators(schema.activityDurationYear.validators)}
            defaultValue={valYear}
            render={(props) => {
              return (
                <SelectPicker
                  disabled={isEdit}
                  value={valYear}
                  style={{ width: 150 }}
                  searchable={false}
                  // data={schema.activityDurationYear.options}
                  data={optionsYear}
                  placeholder={schema.activityDurationYear.hint}
                  onChange={(value) => {
                    onYearChange(props, item, index, value)
                  }}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, width: '11em' }}>
          <Controller
            key={schema.activityDurationMonth.name + '_' + index}
            name={schema.activityDurationMonth.name + '_' + index}
            control={control}
            rules={isValidators(schema.activityDurationMonth.validators)}
            defaultValue={item.month}
            render={(props) => {
              return (
                <SelectPicker
                  // disabled={isEdit}
                  disabled={item.year ? false : true}
                  value={item.month}
                  style={{ width: 150 }}
                  searchable={false}
                  // data={schema.activityDurationMonth.options}
                  // data={optionsMonth}
                  data={optionsMonthData.get(parseInt(valYear))}
                  placeholder={schema.activityDurationMonth.hint}
                  onChange={(value) => {
                    onMonthChange(props, item, index, value)
                  }}
                />
              )
            }}
          />
        </Col>
        {!isEdit && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 10, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon className="bt-gost-icon-radius-cancel" icon="trash" />}
              onClick={() => handleDeleteMonth(index)}
              style={{ marginLeft: 5 }}
            ></IconButton>
          </Col>
        )}

        {ativityMonths.length - 1 === index && !isEdit && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 10, width: 50 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
              onClick={() => handlePlusMonth()}
            ></IconButton>
          </Col>
        )}
      </Row>
    )
  })

  const durationTypeRadio = (
    <>
      <Row style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ControlLabel>
            {requiredFiled(schema.periodType.validators, schema.periodType.label)}
          </ControlLabel>
        </Col>
      </Row>
      <Controller
        key={schema.periodType.name}
        name={schema.periodType.name}
        control={control}
        rules={isValidators(schema.periodType.validators)}
        defaultValue={schema.periodType.value}
        render={(props) => {
          return (
            <RadioGroup
              value={props.value}
              inline
              onChange={(value) => {
                setPeriodType(value)
                setValueOptions()
                props.onChange(value)
                if (value == 1) {
                  setStartEndList([
                    {
                      start: '',
                      end: '',
                    },
                  ])
                  setAtivityMonths([])
                } else {
                  setAtivityMonths([
                    {
                      month: '',
                      year: '',
                    },
                  ])
                  setStartEndList([])
                }
              }}
            >
              {schema.periodType.options.map((item, index) => {
                return (
                  <Radio value={item.value} key={index} disabled={isEdit}>
                    {item.label}
                  </Radio>
                )
              })}
            </RadioGroup>
          )
        }}
      />
    </>
  )

  const handleViewform = () => {
    console.log('handleViewform ')
    setIsEdit(false)
  }

  return (
    <>
      <Panel
        // header={isAdd || isEdit}
        collapsible={isEditDetail ? !isEditDetail : isEditDetail}
        bordered={isEditDetail ? !isEditDetail : isEditDetail}
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {(isAdd || isEdit) && (
          <Form fluid>
            <Controller
              key={selectedId}
              name={selectedId}
              control={control}
              defaultValue={editId}
            />

            {schema.description && (
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  <CustomIconMessageInfo contents={schema.description} />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                {isEdit ? (
                  <>
                    {/* <h5>
                      <b style={{ color: '#2da988' }}>{`${schema.activity.label} : `}</b>
                      {`${schema.activity.value}`}
                    </h5> */}
                  </>
                ) : (
                  <>
                    <ErrorMessage error={errors[schema.activity.name]} />
                    <ControlLabel>
                      {requiredFiled(schema.activity.validators, schema.activity.label)}
                    </ControlLabel>
                    <Controller
                      key={schema.activity.name}
                      name={schema.activity.name}
                      control={control}
                      rules={isValidators(schema.activity.validators)}
                      defaultValue={activityName}
                      render={(props) => {
                        return (
                          <>
                            <Input
                              disabled={isEdit || disableActivityName}
                              //name={schema.activity.name}
                              defaultValue={props.value}
                              placeholder={schema.activity.hint}
                              maxLength={getMaxLengthData(schema.activity.validators)?.value || 250}
                              //inputRef={register(isValidators(schema.activity.validators))}
                              onChange={(value) => {
                                props.onChange(value)
                                setActivityName(value)
                                setTextActivityNameValue(value?.length || 0)
                              }}
                              value={props.value}
                            />
                            <ShowLimitLength
                              textLength={textActivityNameValue}
                              maxLength={getMaxLengthData(schema.activity.validators)?.value || 250}
                            />
                          </>
                        )
                     }}
                    />
                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                {!isEdit && (
                  <>
                    <ControlLabel>{schema.activityDetail.label}</ControlLabel>
                    <Controller
                      key={schema.activityDetail.name}
                      name={schema.activityDetail.name}
                      control={control}
                      rules={isValidators(schema.activityDetail.validators)}
                      defaultValue={activityDetail}
                      render={(props) => {
                        return (
                          <>
                            <Input
                              componentClass="textarea"
                              rows={4}
                              disabled={isEdit}
                              // name={schema.activityDetail.name}
                              defaultValue={props.value}
                              placeholder={schema.activityDetail.hint}
                              maxLength={getMaxLengthData(schema.activityDetail.validators)?.value || 1000}
                              //inputRef={register()}
                              onChange={(value) => {
                                props.onChange(value)
                                setActivityDetail(value)
                                setActivityDetailValue(value?.length || 0)
                              }}
                              value={props.value}
                            />

                            <ShowLimitLength
                              textLength={activityDetailValue}
                              maxLength={getMaxLengthData(schema.activityDetail.validators)?.value || 1000}
                            />
                          </>
                        )
                      }}
                    />
                  </>
                )}
              </Col>
            </Row>

            {schema.actualPeriod == 2 ? (
              <>
                {isAdd && (
                  <>
                    <Row style={{ marginTop: 10 }}>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ControlLabel>
                          {requiredFiled(
                            schema.activityDurationExpectedStart.validators,
                            schema.activityDurationExpectedStartText
                          )}
                        </ControlLabel>
                        <ErrorMessage error={errors[schema.activityDurationExpectedStart.name]} />
                        <InputGroup>
                          <InputGroup.Addon>
                            <p>{schema.activityDurationExpectedStart.preLabel}</p>
                          </InputGroup.Addon>
                          <Controller
                            key={schema.activityDurationExpectedStart.name}
                            name={schema.activityDurationExpectedStart.name}
                            control={control}
                            rules={isValidators(schema.activityDurationExpectedStart.validators)}
                            defaultValue={schema.activityDurationExpectedStart.value}
                            render={(props) => {
                              return (
                                <NumberFormat
                                  className="rs-input"
                                  disabled={isEdit}
                                  thousandSeparator={true}
                                  value={props.value}
                                  placeholder={schema.activityDurationExpectedStart.hint}
                                  onValueChange={(e) => {
                                    props.onChange(e.floatValue)
                                  }}
                                />
                              )
                            }}
                          />
                          <InputGroup.Addon>
                            <p>{schema.activityDurationExpectedStart.postLabel}</p>
                          </InputGroup.Addon>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 10 }}>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <ErrorMessage error={errors[schema.totalMonth.name]} />
                        <InputGroup>
                          <InputGroup.Addon>
                            <p>{schema.totalMonth.preLabel}</p>
                          </InputGroup.Addon>
                          <Controller
                            key={schema.totalMonth.name}
                            name={schema.totalMonth.name}
                            control={control}
                            rules={isValidators(schema.totalMonth.validators)}
                            defaultValue={schema.totalMonth.value}
                            render={(props) => {
                              return (
                                <NumberFormat
                                  className="rs-input"
                                  disabled={isEdit}
                                  thousandSeparator={true}
                                  value={props.value}
                                  placeholder={schema.totalMonth.hint}
                                  onValueChange={(e) => {
                                    props.onChange(e.floatValue)
                                  }}
                                />
                              )
                            }}
                          />
                          <InputGroup.Addon>
                            <p>{schema.totalMonth.postLabel}</p>
                          </InputGroup.Addon>
                        </InputGroup>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ) : (
              <>
                {isAdd && (
                  <>
                    {durationTypeRadio}

                    {periodType == 1 ? (
                      <Row>
                        <Controller
                          key={schema.activityDurationDate.name}
                          name={schema.activityDurationDate.name}
                          control={control}
                          rules={isValidators(schema.activityDurationDate.validators)}
                          defaultValue={startEndList}
                        />
                        {renderStartEndDate()}

                        {startEndList.length === 0 && !isEdit && (
                          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, width: 50 }}>
                            <IconButton
                              appearance="ghost"
                              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                              onClick={() => handlePlusDate()}
                            ></IconButton>
                          </Col>
                        )}
                      </Row>
                    ) : (
                      <Row>
                        <Controller
                          key={schema.activityDurationMonth.name}
                          name={schema.activityDurationMonth.name}
                          control={control}
                          rules={isValidators(schema.activityDurationMonth.validators)}
                          defaultValue={ativityMonths}
                        />

                        {renderAtivityMonths}

                        {ativityMonths.length === 0 && !isEdit && (
                          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, width: 50 }}>
                            <IconButton
                              appearance="ghost"
                              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                              onClick={() => handlePlusMonth()}
                            ></IconButton>
                          </Col>
                        )}
                      </Row>
                    )}
                  </>
                )}
              </>
            )}

            {isAdd && (
              <>
                <hr />
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <ControlLabel>
                      {requiredFiled(schema.underPurpose.validators, schema.underPurpose.label)}
                    </ControlLabel>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <Controller
                      // key={schema.underPurpose.name}
                      name={schema.underPurpose.name}
                      control={control}
                      rule={isValidators(schema.underPurpose.validators)}
                      defaultValue={schema.underPurpose.value}
                      render={(props) => {
                        return (
                          <RadioGroup
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                            }}
                          >
                            {schema.underPurpose?.options?.map((item, index) => (
                              <Radio value={item.value} key={index} disabled={isEdit}>
                                {item.label}
                              </Radio>
                            ))}
                          </RadioGroup>
                        )
                      }}
                    />
                  </Col>
                </Row>
              </>
            )}

            {isSaveError && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`บันทึก ${
                    schema?.activity?.label ? schema?.activity?.label : ''
                  } ไม่สำเร็จ`}
                />
              </Row>
            )}

            {!isEdit && (
              <Row style={{ marginTop: '10px' }}>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                  <div>
                    <IconButton
                      appearance="ghost"
                      icon={
                        <Icon className={'bt-gost-icon-radius'} icon={!editId ? 'save' : 'edit'} />
                      }
                      onClick={onSubmit}
                      style={{ marginRight: 5 }}
                      disabled={loading}
                    >
                      {!editId ? 'บันทึก' : 'บันทึกแก้ไข'}
                      {schema?.activity?.label || ''}
                    </IconButton>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                      onClick={(e) => {
                        setIsAdd(false)
                        setIsDeleteFail(false)
                        setIsSaveError(false)
                        scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
                      }}
                      style={{ marginRight: 5 }}
                      disabled={loading}
                    >
                      {`ยกเลิก${schema?.activity?.label || ''}`}
                    </IconButton>
                  </div>
                </Col>
              </Row>
            )}
          </Form>
        )}
        {!isAdd && !isEdit && !schema.disabled && (
          <Row style={{ marginTop: '10px' }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 5 }}>
              <div>
                <IconButton
                  appearance="ghost"
                  icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                  onClick={onAdd}
                  style={{ marginRight: 5 }}
                >
                  {`เพิ่ม${schema?.activity?.label || ''}`}
                </IconButton>
              </div>
            </Col>
          </Row>
        )}
        {!isEdit && (
          <>
            {isDeleteFail && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`ลบ${schema?.activity?.label || ''}ไม่สำเร็จ`}
                />
              </Row>
            )}
            <Row style={{ marginTop: 10 }}>
              <ActivityBudgetTable
                schema={schema}
                isEdit={true}
                onDelete={onDelete}
                onEdit={handleOnEdit}
                onEditActivityBudget={handleEditActivityBudget}
              />
            </Row>
          </>
        )}
      </Panel>

      {isEdit && (
        <div style={{ marginTop: 10 }}>
          {isLoading ? (
            <PanalLoadingTemplate />
          ) : (
            <>
              {activityProductivitySchema && (
                <div>
                  <ActivityProductivityWidget
                    bordered
                    forceEdit={isEditDetail}
                    // showCommandButton={isEditDetail}
                    showCommandButtonAc={true}
                    isEditAll={isEditDetail}
                    collapsible={true}
                    defaultExpanded={true}
                    activityId={editId}
                    expanded={panelExpanded}
                    schema={activityProductivitySchema}
                    onBackToViewAcBudgetForm={handleViewform}
                    projectVersionId={projectVersionId}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}
